<div class="content-block light-control-host">
  <h1>Need Support?</h1>
  <p>The Arpio team is ready to help! Click below to open a ticket. We typically reply within 4 business hours.</p>
  <button type="button" class="link-button arpio-button" (click)="showTicketForm()">Open a ticket</button>
  <h2 class="margin-top block-header">Want to talk with us instead?</h2>
  <p>
    Feel free to launch a live chat with our team. We are available between 9am-9pm Eastern Time, Monday - Friday. For
    urgent issues, you can call us anytime.
  </p>
  <div>
    <button type="button" class="link-button arpio-button" (click)="uiService.openChat()">Chat with us</button>
    <a href="tel:{{ supportNumber }}">
      <button type="button" class="arpio-button link-button arpio-danger-button">Call {{ supportNumber }}</button> </a
    >.
  </div>
  <p>
    If the above methods are not working, we also have a
    <a [routerLink]="" (click)="showBackupNumber()">backup phone number</a>.
  </p>
  <p *ngIf="backupNumberVisible">
    Backup number: <a href="tel:{{ backupNumber }}">{{ backupNumber }}</a>
  </p>
</div>

<modal-dialog #submitTicketDialog [dialogTemplate]="submitTicketDialogTemplate"></modal-dialog>
<ng-template #submitTicketDialogTemplate>
  <div class="light-content-panel light-control-host">
    <h2 class="panel-title margin-left">Open a ticket</h2>
    <form class="support-form" [formGroup]="createTicketFormModel" (submit)="openTicket()">
      <fieldset style="grid-column: 1; grid-row: 1">
        <label for="yourEmail">Your email</label>
        <input id="yourEmail" class="arpio-input" type="email" formControlName="email" focus-element />
      </fieldset>
      <fieldset style="grid-column: 2; grid-row: 1">
        <label for="ticketPriority">Priority</label>
        <div id="ticketPriority" class="select-wrapper">
          <select class="arpio-select full-width" formControlName="ticketPriority">
            <option value="LOW" [selected]="true">Low</option>
            <option value="MEDIUM">Medium</option>
            <option value="HIGH">High</option>
          </select>
        </div>
      </fieldset>
      <fieldset style="grid-column: 1 / 3; grid-row: 2">
        <label for="ticketSubject">Subject</label>
        <input id="ticketSubject" class="arpio-input" type="text" formControlName="ticketSubject" />
      </fieldset>
      <fieldset style="grid-column: 1 / 3; grid-row: 3 / 5">
        <label for="ticketContent">Description</label>
        <textarea id="ticketContent" class="arpio-input" formControlName="ticketContent"></textarea>
      </fieldset>
      <fieldset style="grid-column: 1; grid-row: 5">
        <button type="button" class="arpio-secondary-button float-right" (click)="hideTicketForm()">Cancel</button>
      </fieldset>
      <fieldset style="grid-column: 2; grid-row: 5">
        <button type="submit" busy-button [busy]="openingTicket" class="arpio-button">Submit</button>
      </fieldset>
    </form>
  </div>
</ng-template>
<modal-dialog #confirmTicketDialog [dialogTemplate]="ticketConfirmationDialogTemplate"></modal-dialog>
<ng-template #ticketConfirmationDialogTemplate>
  <div class="light-content-panel light-control-host">
    <h2 class="panel-title margin-left">Ticket opened</h2>
    <div class="margin" [innerHTML]="hubspotResponse"></div>
    <div class="margin-left">
      <button type="button" class="arpio-secondary-button" (click)="confirmTicketDialog.close()">Close</button>
    </div>
  </div>
</ng-template>
